const FiltroSituacaoTarefaEnum = {
  C: 'CONCLUIDAS',
  NC: 'NAO_CONCLUIDAS'
}

export default FiltroSituacaoTarefaEnum



// WEBPACK FOOTER //
// ./client/enum/tipoFiltroSituacaoTarefas.js